export default function PaletteComponentStyle() {
  return (
    <style>
      {`

          .palette-container {
          width: 100%;
          overflow-x: auto;
          }

          .palette-rows {
          width: 100%;
          display: flex;
          flex-direction: column;
          }

          .palette-row {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          transition: opacity 0.2s, background-color 0.2s;
          width: 100%;
          min-height: 40px;
          background-color: #f8f9fa;
          border: 1px solid #eee;
          border-top-width: 0;
          z-index: 3;
          }

          .palette-row-main, .palette-row-sub {
          display: flex;
          width: 100%;
          padding: 8px;
          align-items: center;
          }

          .palette-row-sub {
          max-height: 0;
          padding: 0;
          opacity: 0;
          pointer-events: none;
          }

          .palette-row--editing .palette-row-sub {
          display: flex;
          margin-top: 0;
          padding: 8px 4px;
          max-height: 500px;
          opacity: 1;
          pointer-events: auto;
          }

          .palette-row:hover {
          filter: brightness(0.98);
          }

          .palette-category, .palette-product:first-child {
          border-top-width: 1px;
          border-top-left-radius: 4px;
          border-top-right-radius: 4px;
          }

          .palette-category {
          background-color: #ecedee;
          border-left: 6px solid var(--bs-primary, black);
          font-weight: 600;
          }

          .category-group:not(:first-child) {
          margin-top: 2rem;
          }

          .palette-product .palette-cell--icon {
          margin-left: 3px;
          }

          .palette-category .palette-category-name {
          font-size: larger;
          }

          .palette-row:not([data-show="true"]) {
          font-weight: normal;
          opacity: 0.8;
          border-left-color: #ddd;
          }

          .palette-product:not([data-show="true"]) {
          background-color: #ffffff;
          }
          .palette-category:not([data-show="true"]) {
          background-color: #f2f3f4;
          }

          .palette-category-name {
          flex-grow: 2;
          }

          .palette-cell {
          padding: 4px 8px;
          flex: 1;
          min-width: 0;
          transition: flex 0.2s ease;
          }

          .palette-cell--icon {
          flex: 0 0 30px;
          display: flex;
          justify-content: space-evenly;
          padding-left: 0;
          }

          .palette-actions-cell {
          flex: 0 0 60px;
          display: flex;
          justify-content: flex-end;
          gap: 8px;
          }

          .palette-row-dragging {
          opacity: 0.5 !important;
          }

          .palette-cell-icon {
          padding: 2px 4px;
          user-select: none;
          display: inline-block;
          padding: 2px 4px;
          }

          .palette-drag-handle {
            cursor: grab;
            touch-action: none;
          }

          .palette-drag-handle:hover {
          cursor: grab;
          color: #3498db;
          }

          .category-controls {
          display: flex;
          gap: 4px;
          align-items: center;
          }

          .palette-control-handle {
          cursor: pointer;
          display: inline-block;
          }

          .palette-control-handle:hover {
          color: #3498db;
          }

          .palette-cell[data-column=name] {
          flex: 3
          }
          .palette-cell[data-column=price] {
          flex: 1
          }

          .palette-editable-container {
          position: relative;
          width: 100%;
          height: 100%;
          }

          .palette-explicit-placeholder {
          position: absolute;
          top: 0;
          left: 0;
          color: #aaa;
          font-style: italic;
          pointer-events: none;
          z-index: 1;
          }

          .palette-editable {
            width: 100%;
            border: 1px solid transparent;
            background-color: transparent;
            border-radius: 4px;
            padding-top: 5px;
            padding-bottom: 5px;
            margin-top: -5px;
            margin-bottom: -5px;

            padding-left: 5px;
            padding-right: 5px;
            margin-left: -5px;
            margin-right: -5px;
            resize: none;
            overflow-y: hidden;
            vertical-align: middle;
          }

          .palette-editable:hover, .palette-editable:focus {
            background-color: #f8f9fa;

            border: 1px solid #dee2e6;
          }

          .palette-editable:focus {
            outline: none;
            height: auto;
            background-color: #eaedf0;
            border-color: var(--main-border-light, #dee2e6);
          }

          .palette-buttons-container {
          margin-top: 15px;
          display: flex;
          gap: 1rem;
          justify-content: center;
          }

          /* Cursor styles */
          body.palette-cursor-grabbing {
          cursor: grabbing !important;
          }

          .palette-cursor-grabbing * {
          cursor: grabbing !important;
          }


          `}
    </style>
  );
}
